import { z } from "zod";
import { PasswordType } from "./base.validator";

export const changePassword = z.object({
	oldPassword: z.string(),
	newPassowrd: z.string(),
});

export type ChangePasswordDto = z.infer<typeof changePassword>;

export const changePasswordInput = z
	.object({
		oldPassword: z.string().optional(),
		newPassword: PasswordType,
		confirmPassword: z.string().optional(),
		otp: z.string().optional(),
	})
	.refine((data) => data.newPassword === data.confirmPassword, {
		path: ["confirmPassword"],
		message: "Passwords does not match",
	});

export type ChangePasswordInputDto = z.infer<typeof changePasswordInput>;

export const changePasswordResponseDto = z.object({
	message: z.string(),
});

export type ChangePassworResponseDto = z.infer<
	typeof changePasswordResponseDto
>;
